import IconButton from '@material-ui/core/IconButton'
import { makeStyles, styled } from '@material-ui/core/styles'
import {
  getFilterMenuItemSelectedStyles,
  getFilterMenuLeadingStyles,
} from '@components/coaches-search/filter-menu-item.styles'
import {
  DIRECTORY_RESULTS_GUTTER,
  DIRECTORY_RESULTS_MAX_WIDTH,
} from './directory-results-layout'

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    marginBottom: '60px',
  },
  breadcrumbs: {
    padding: '40px 0 0',
  },
  searchField: {
    width: '100%',
    margin: '40px 0 60px 0',

    [theme.breakpoints.down('xs')]: {
      margin: '20px 0',
    },
  },
  refiners: {
    [theme.breakpoints.only('xs')]: {
      paddingBottom: '0px !important',
    },
  },
  directoryPageHero: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    // Nav dropdown panel uses 2.5rem padding plus a spacing(3) gutter.
    paddingTop: 'calc(2.5rem + 24px)',
    paddingBottom: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      paddingTop: '2.5rem',
    },
  },
  directoryPageHeroText: {
    maxWidth: 640,
    width: '100%',
  },
  directoryHeading: {
    ...theme.typography.h4,
    color: '#00234B',
    marginBottom: 0,
  },
  filtersLine: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
    margin: `${theme.spacing(1)}px auto ${theme.spacing(3)}px`,
    background: 'none',
    border: 'none',
    boxShadow: 'none',
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(1.25),
      marginBottom: theme.spacing(2),
    },
  },
  splitSearchBar: {
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto',
    width: 440,
    maxWidth: '100%',
    minHeight: 56,
    padding: theme.spacing(0.5, 0.75, 0.5, 1.5),
    backgroundColor: theme.palette.common.white,
    borderRadius: 999,
    border: 'none',
    boxShadow: '0 10px 28px rgba(15, 34, 52, 0.12)',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      width: '100%',
      borderRadius: 16,
      padding: theme.spacing(1, 1.25),
      gap: theme.spacing(0.25),
    },
  },
  splitFocusTrigger: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: '0 1 auto',
    minWidth: 132,
    maxWidth: 200,
    height: 44,
    minHeight: 44,
    padding: theme.spacing(0, 1, 0, 0.25),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      maxWidth: 'none',
      minWidth: 0,
      flex: '1 1 auto',
      height: 'auto',
      minHeight: 44,
    },
    textTransform: 'none',
    textAlign: 'left',
    border: 'none',
    borderRadius: 0,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  splitFocusTriggerOpen: {
    backgroundColor: 'transparent',
  },
  splitFocusTriggerActive: {
    '& $splitFocusValue': {
      color: '#3268A7',
    },
    '& $splitFocusIcon': {
      color: '#3268A7',
    },
  },
  splitFocusIcon: {
    flexShrink: 0,
    color: '#00234B',
    marginRight: theme.spacing(0.75),
  },
  splitFocusValue: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(16),
    color: '#00234B',
    paddingRight: theme.spacing(0.5),
    [theme.breakpoints.down('xs')]: {
      overflow: 'visible',
      textOverflow: 'clip',
      whiteSpace: 'normal',
    },
  },
  splitSearchDivider: {
    alignSelf: 'center',
    height: 28,
    margin: theme.spacing(0, 0.5),
    backgroundColor: '#e0e6ed',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  filtersLineMenus: {
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto',
    width: '100%',
    minWidth: 0,
    justifyContent: 'center',
  },
  contextDropdownCaret: {
    flexShrink: 0,
    color: '#6f7988',
    width: 18,
    height: 18,
    transition: theme.transitions.create('transform', { duration: theme.transitions.duration.shorter }),
  },
  contextDropdownCaretOpen: {
    transform: 'rotate(180deg)',
  },
  splitNearAutocomplete: {
    flex: 1,
    minWidth: 0,
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'transparent',
      borderRadius: 0,
      minHeight: 44,
      paddingRight: theme.spacing(0.5),
      cursor: 'pointer',
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(16),
      cursor: 'pointer',
      '&:focus': {
        cursor: 'text',
      },
    },
    // Keep pin + city on one row. `width: 100%` with Autocomplete's
    // `flexWrap: wrap` collapses the adornment and hides the city list.
    '& .MuiAutocomplete-inputRoot': {
      flexWrap: 'nowrap',
    },
    '& .MuiInputAdornment-root': {
      cursor: 'pointer',
      height: 'auto',
      alignSelf: 'center',
    },
    '& .MuiInputAdornment-positionStart': {
      marginRight: theme.spacing(0.5),
    },
    '& .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator': {
      display: 'none',
    },
  },
  splitLocationCluster: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      flex: '1 1 auto',
      paddingTop: theme.spacing(0.75),
      borderTop: '1px solid #e0e6ed',
    },
  },
  splitSearchButton: {
    width: 40,
    height: 40,
    padding: 0,
    borderRadius: '50%',
    cursor: 'pointer',
    color: theme.palette.common.white,
    backgroundColor: '#00234B',
    '&:hover': {
      backgroundColor: '#143d66',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 20,
    },
  },
  contextAutocompletePaper: {
    marginTop: theme.spacing(0.5),
    borderRadius: 10,
    boxShadow: '0 8px 24px rgba(15, 34, 52, 0.14)',
    border: '1px solid #dfe3ea',
  },
  contextAutocompleteOption: {
    cursor: 'pointer',
  },
  contextLocationIcon: {
    color: '#3268A7',
  },
  filterMenuPaper: {
    borderRadius: 8,
    backgroundColor: theme.palette.common.white,
    border: '1px solid rgba(15, 50, 84, 0.08)',
    boxShadow: '0 6px 20px rgba(15, 34, 52, 0.12), 0 2px 6px rgba(15, 34, 52, 0.06)',
    minWidth: 220,
    marginTop: theme.spacing(0.5),
  },
  filterMenuItem: {
    minHeight: 44,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    cursor: 'pointer',
  },
  filterMenuItemSelected: getFilterMenuItemSelectedStyles(theme),
  ...getFilterMenuLeadingStyles(theme),
  filterAndSort: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    flexDirection: 'column',

    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
    },
  },
  hideFiltersFlex: {
    fontWeight: 600,
    margin: '0px 5px',
    alignItems: 'center',
    display: 'flex',
    cursor: 'pointer',
  },
  bggShowAllBtn: {
    padding: 0,
    height: '20px',
  },
  hideFiltersBtn: {
    padding: '5px 0',
  },
  sortBoxStyles: {
    fontWeight: 600,
  },
  resultsString: {
    fontFamily: 'Nunito Sans',
    [theme.breakpoints.only('xs')]: {
      fontSize: '16px',
    },
  },
  // Results count line between the filter row and the coach grid.
  // locate-fixed + "{N} coaches near {City, ST}" when placeName is complete,
  // otherwise "{N} coaches available"; then "{M} are certified [PGA of America Members]".
  // Centered so it still sits over leftover 1–2 cards (the grid is also centered).
  // Membership phrase is a bold navy underline that opens the explainer.
  resultsCountRow: {
    maxWidth: DIRECTORY_RESULTS_MAX_WIDTH,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: DIRECTORY_RESULTS_GUTTER,
    paddingRight: DIRECTORY_RESULTS_GUTTER,
    marginTop: theme.spacing(1),
    marginBottom: 0,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(0.75),
    },
  },
  resultsCountLocateIcon: {
    color: '#63666A',
    display: 'block',
    flexShrink: 0,
    marginTop: '0.12em',
  },
  resultsCountGridItem: {
    paddingBottom: `${theme.spacing(2)}px !important`,
  },
  resultsGridSection: {
    paddingTop: `${theme.spacing(1)}px !important`,
  },
  eventBannerGridItem: {
    paddingLeft: `${theme.spacing(3)}px !important`,
    paddingRight: `${theme.spacing(3)}px !important`,
  },
  resultsCountHeading: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: theme.spacing(0.75),
    maxWidth: '100%',
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400,
    lineHeight: 1.45,
    color: '#63666A',
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(13),
    },
  },
  resultsCountText: {
    flex: '1 1 auto',
    minWidth: 0,
    textAlign: 'left',
  },
  resultsCountMembershipLink: {
    display: 'inline',
    margin: 0,
    padding: 0,
    border: 0,
    background: 'none',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 700,
    lineHeight: 'inherit',
    color: '#00234B',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover, &:focus-visible': {
      color: '#001123',
    },
    '&:focus-visible': {
      outline: '2px solid #00234B',
      outlineOffset: 2,
    },
  },
  // Legacy alias kept for any downstream references during the persona rollout.
  resultsCount: {
    flex: 1,
    minWidth: 0,
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('xs')]: {
      fontSize: '15px',
    },
  },
  // Mirrors the saved-offerings circular toggle on `/golf-lessons`
  // (`pga-coach-search.styles.js#savedOfferingsFilterCircle`): 36px disc,
  // outlined heart when off, blue-fill heart when on. Disabled until the
  // user has saved at least one coach so the affordance reads as inert
  // rather than broken.
  savedCoachesToggle: {
    width: 36,
    height: 36,
    padding: 0,
    borderRadius: '50%',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #dfe3ea',
    '&:hover': {
      backgroundColor: theme.palette.blue.light25,
      borderColor: theme.palette.blue.main,
      color: theme.palette.blue.main,
    },
    '&.Mui-disabled': {
      color: '#c7ccd3',
      backgroundColor: theme.palette.common.white,
    },
  },
  savedCoachesToggleActive: {
    color: theme.palette.blue.main,
    backgroundColor: theme.palette.blue.light25,
    borderColor: theme.palette.blue.main,
    '&:hover': {
      color: theme.palette.blue.main,
      backgroundColor: theme.palette.blue.light25,
      borderColor: theme.palette.blue.main,
    },
  },
}))

export const StyledIconButton = styled(IconButton)({
  '&.MuiIconButton-root': {
    borderRadius: '0',
  },
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
})
